import { configWithAuth } from '../helpers'
import { makeGetRequest, makePostRequest, makeDeleteRequest } from '../helpers/api'

export const apiKeyService = {
    getApiKeysForOrganization: (organizationId, includeAll = true) =>
        makeGetRequest(
            `admin/api/key/organization/${organizationId}?includeAll=${includeAll}`,
            configWithAuth()
        ),

    createApiKey: (organizationId, apiKeyCreateDto) =>
        makePostRequest(
            `admin/api/key/organization/${organizationId}`,
            JSON.stringify(apiKeyCreateDto),
            configWithAuth()
        ),

    deleteApiKey: (organizationId, apiKeyId) =>
        makeDeleteRequest(
            `admin/api/key/organization/${organizationId}/${apiKeyId}`,
            {},
            configWithAuth()
        ),
}
